var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"add-btn btn--circle",attrs:{"type":"button"}},_vm.$listeners),[_c('span',{staticClass:"add-icon material-icons text-blue"},[_vm._v(" add ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }